// extracted by mini-css-extract-plugin
export default {"plus_menu":"plus_menu___Tt4i9","show":"show___a2HGp","closed":"closed___dGCRF","container":"container___epXUW","benefits":"benefits___N3isa"};